import { TranslationsContext, useIsMobileHook } from '@telia-common-components/shared';
import React from 'react';
import { Carousel, CarouselItem, EqualHeightProvider, Notice, Skeleton, SkeletonItem } from 'telia-front-react';
import { useGo3AppData } from './Go3AppDataProvider';
import { FetchStatus } from '../../../util/FetchStatus';
import { Go3AppCarouselCard } from './Go3AppCarouselCard';
export const Go3AppCarouselContent = (props) => {
    const { tags } = props;
    const { translate } = React.useContext(TranslationsContext);
    const { isMobile } = useIsMobileHook();
    const { go3AppDataState, fetchGo3AppData } = useGo3AppData();
    React.useEffect(() => {
        fetchGo3AppData();
    }, []);
    const renderSkeletonItems = () => {
        return [...Array(4).keys()].map((key) => (React.createElement(CarouselItem, { key: key },
            React.createElement(Skeleton, { key: key, label: translate('skeleton.loading') },
                React.createElement(SkeletonItem, { height: '566px' })))));
    };
    const renderOffers = () => {
        return go3AppDataState.data.map((app) => {
            var _a;
            return (React.createElement(CarouselItem, { key: `go3-app-${app.productOfferingCode}` },
                React.createElement(Go3AppCarouselCard, { go3App: app, productCode: app.productOfferingCode, tagText: (_a = tags === null || tags === void 0 ? void 0 : tags.find((t) => t.productCode === app.productOfferingCode)) === null || _a === void 0 ? void 0 : _a.tagText })));
        });
    };
    const shouldShowSkeleton = () => {
        return [FetchStatus.UNINITIALIZED, FetchStatus.FETCHING].includes(go3AppDataState.status);
    };
    if (FetchStatus.ERROR === go3AppDataState.status) {
        return React.createElement(Notice, { type: "error" }, translate('general.error.message'));
    }
    return (React.createElement(EqualHeightProvider, { groups: ['heading', 'content', 'inclusion', 'price'] },
        React.createElement(Carousel, { nextArrowText: translate('carousel.next'), prevArrowText: translate('carousel.previous'), arrows: !isMobile, align: "left", hasContainer: true, breakPoint: null, slidesToShow: 1, responsive: [
                {
                    breakPoint: 'sm',
                    props: { slidesToShow: 2 }
                },
                {
                    breakPoint: 'md',
                    props: { slidesToShow: 3 }
                },
                {
                    breakPoint: 'lg',
                    props: { slidesToShow: 4 }
                }
            ] }, shouldShowSkeleton() ? renderSkeletonItems() : renderOffers())));
};
